import React from 'react';

function StaticApp () {
    return <div></div>
}

export default StaticApp;